/*
 * @Author: Src
 * @Date: 2024-12-16 17:02:21
 * @LastEditTime: 2025-08-08 13:46:20
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/di.ts
 * @Description: 头部注释配置模板
 */
import { Container } from 'inversify';
import getDecorators from 'inversify-inject-decorators';
import 'reflect-metadata';
import AdRegistrationService from './services/ad.registration.service';
import BIService from './services/bi.service';
import BossReportService from './services/boss.report.service';

import HttpClient from './services/http.service';
import StorageService from './services/storage.service';
import AuthService from './services/auth.service';
import UserService from './services/user.service';
import ShopService from './services/shop.service';
import PrivacyService from './services/privacy.service';
import CarService from './services/car.service';

// import CityService from './services/city.service';

const container = new Container({
  skipBaseClassChecks: true,
});

container.bind<BIService>(BIService).to(BIService);
container.bind<BossReportService>(BossReportService).to(BossReportService);
container.bind<HttpClient>(HttpClient).to(HttpClient);
container.bind<StorageService>(StorageService).to(StorageService);
container.bind<AuthService>(AuthService).to(AuthService);
container.bind<UserService>(UserService).to(UserService);
container
  .bind<AdRegistrationService>(AdRegistrationService)
  .to(AdRegistrationService);
container.bind<ShopService>(ShopService).to(ShopService);
container.bind<PrivacyService>(PrivacyService).to(PrivacyService);
container.bind<CarService>(CarService).to(CarService);


// container.bind<CityService>(CityService).to(CityService);
const { lazyInject } = getDecorators(container, false);

export default lazyInject;
